// extracted by mini-css-extract-plugin
var _1 = "oMzoPySvVFE8hfqymOrz";
export { _1 as "root" }
